import { BaseError, ErrorChanel } from 'ngx-unificator/errors';

export class GameSyncError extends BaseError {
  public key: string;
  public chanel: ErrorChanel = ErrorChanel.QA;
  public type = 'game-sync-error';
  public name = 'GameSyncError';

  constructor(key: string) {
    super(`Error in game => ${key}, Need run game sync!`);
    this.key = key;
  }
}
